module.exports = __webpack_public_path__ + "toBride1-we-r-b.ec59a97b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-r-b.jpg
// module id = Ks4O
// module chunks = 0